import { login, UserLogin, logout } from '@/api/user';
import { getToken, setToken, removeToken, getUserInfo } from '@/utils/auth';

const getDefaultState = () => {
  return {
    token: getToken(),
    userInfo: getUserInfo() || {},
    roles: [],
    istoken: false
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: state => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_USER: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  }
};

const actions = {
  // user login
  login({ commit }, code) {
    return new Promise((resolve, reject) => {
      login({ code: code })
        .then(response => {
          if (response.userInfo.userId === 'songshuo' || response.userInfo.isMoni) {
            // eruda.init();
            console.log('控制台打印信息');
            console.log(response);
          }
          commit('SET_TOKEN', response.token);
          commit('SET_USER', response.userInfo);
          setToken(response.token, response.userInfo)
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  UserLogin({ commit }, data) {
    return new Promise((resolve, reject) => {
      UserLogin(data)
        .then(response => {
          commit('SET_TOKEN', response.token);
          commit('SET_USER', response.userInfo);
          setToken(response.token, response.userInfo);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        removeToken() // must remove  token  first
        commit('RESET_STATE')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken(); // must remove  token  first
      commit('RESET_STATE');
      resolve();
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
